export const Timeouts = {
  TIMEOUT_100: 100,
  TIMEOUT_300: 300,
  TIMEOUT_1000: 1000,
  TIMEOUT_2000: 2000,
  TIMEOUT_5000: 5000
}
